import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "top-0 left-0 right-0 sticky z-999" }
const _hoisted_3 = { class: "h-full flex bg-gray-100 overflow-y-scroll" }
const _hoisted_4 = { class: "flex w-calc-100%-300p" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")
  const _component_SidebarMap = _resolveComponent("SidebarMap")
  const _component_transition_router_view = _resolveComponent("transition-router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Nav)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_SidebarMap, { class: "w-300" }),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_transition_router_view)
      ])
    ])
  ]))
}